import React, { useState, useEffect, useReducer } from "react"
import { Formik, Field } from "formik"
import { returnDynamicValidation } from "./Validation"
import { renderTextInput } from "components/forms/SharedInputs"

import { AddressFields, NameFields } from "./Fields"
import * as Yup from "yup"
import Uploads from "./Uploads"
import Checkbox from "@material-ui/core/Checkbox"

import "./ReviewView.scss"

const rewardReducer = (state, action) => {
  switch (action.type) {
    case "changeReward":
      console.log("changeReward action fired. the new reward is: ", action.payload)
      const dynamicValidation = state => {
        const { nameRequired, addressRequired, phoneRequired, customConfirmation } = state
        let customConfirmationExists = customConfirmation && customConfirmation.length > 0 ? true : false
        let smartValidation = returnDynamicValidation(nameRequired, addressRequired, phoneRequired, customConfirmationExists)
        return Yup.object().shape(smartValidation)
      }
      let reward = action.payload
      let confirmationCopy = reward.confirmationCopy ? reward.confirmationCopy : ""
      let theNewState = {
        nameRequired: reward.requireName,
        phoneRequired: reward.requirePhoneNumber,
        addressRequired: reward.requireAddress,
        customConfirmation: confirmationCopy,
      }
      let smartValidation = dynamicValidation(theNewState)
      return {
        ...theNewState,
        validationSchema: smartValidation,
      }
    default:
      return state
  }
}

const SubmissionForm = ({ uploadID, uploadSuccessful, rewardOptions = [], reviewListHeader, instructions = [], children, editMySubmission, onFormSubmission, nonFieldErrors = [] }) => {
  //initialize form state with reducer
  let initialState = {
    nameRequired: false,
    phoneRequired: false,
    addressRequired: false,
    customConfirmation: "",
    validationSchema: null,
  }
  const [state, dispatch] = useReducer(rewardReducer, initialState)
  const [addressValid, setAddressValidityUSPS] = useState(null)
  //onload, pull initial values to make sure that the first reward is selected
  useEffect(() => {
    console.log("this useEffect should only run once")
    dispatch({ type: "changeReward", payload: rewardOptions[0] })
  }, [])

  // reshape the form options beaker spits out and make 'em work for us
  const formRewardOptions = rewardOptions.map(option => ({
    label: option.title,
    value: option.id,
    key: option.id,
  }))

  const initialValues = {
    email: "",
    phone: "",
    termsAccepted: false,
    address1: "",
    address2: "",
    city: "",
    state: "",
    postalCode: "",
    firstName: "",
    lastName: "",
    customConfirmation: "",
  }
  if (rewardOptions && rewardOptions.length > 0) {
    initialValues.rewardId = formRewardOptions[0].value
  }

  const validateAddressUSPS = async (values) => {
    let url = `${process.env.DAILYBREAK_API_URL}/user/validate-address`
    let addressValues = {
      address1: values.address1,
      address2: values.address2,
      city: values.city,
      state: values.state,
      zip: values.postalCode,
      zip2: ""
    }
    let addressValidity = await fetch(url, {
      method: "POST",
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
      body: JSON.stringify(addressValues),
    }).then((res) => {
      return res.json()
    }).then((data) => {
      if (data === true) {
        onFormSubmission(values)
      } else {
        setAddressValidityUSPS(false)
        return false
      }
    }).catch((err) => console.log(err))
    return addressValidity
  }

  return (
    <Formik
      validateOnBlur={false}
      validateOnChange={false}
      initialValues={initialValues}
      validationSchema={state.validationSchema}
      onSubmit={values => {
        validateAddressUSPS(values)
      }}>
      {props => {
        const { values, handleSubmit, setFieldValue, errors, touched } = props

        return (
          <form className={`receipt-review-form`} onSubmit={handleSubmit} key={`formik-review-form`} autocomplete>
            <ul className="form__elements" key={`formik-field-elements`}>

              <li className="form__element form__element-pet-name" key={`formik-field-petname`}>
                <Field name={`pet_name`} type="text" component={renderTextInput} variant="filled" label={`Pet Name(s)*`} placeholder={"Pet Name"} />
                {/* {errors.email && <p className="error">{errors.email}</p>} */}
              </li>
              
              <li className="form__element form__element-caption" key={`formik-field-1`}>
                <Field name={`caption`} id={`caption`} type="textarea" multiline={true} rows={3} inputProps={{maxLength: 325}} component={renderTextInput} variant="filled" label={`Caption*`} placeholder={"Caption"} />
                {/* {errors.email && <p className="error">{errors.email}</p>} */}
              </li>
              

              {<NameFields {...props} />}

              <li className="form__element form__element-email" key={`formik-field-2`}>
                <Field name={`email`} type="email" component={renderTextInput} variant="filled" label={`Email Address*`} autocomplete={"email"} placeholder={"Email"} />
                {errors.email && <p className="error">{errors.email}</p>}
              </li>

              <li className="form__element" key={`phoneNumber`}>
                  <div className="input-row">
                    <Field name={`phoneNumber`} id={`phoneNumber`} type="phone" component={renderTextInput} variant="filled" label={`Phone Number*`} placeholder={"Phone Number"} />
                  </div>
                  <div className="input-row">{errors.phoneNumber && <p className="error">{errors.phoneNumber}</p>}</div>
                </li>

              {state.addressRequired && <AddressFields {...props} />}

              <li className="form__element" key={`formik-field-confirm-items`}>
                <div className={"confirm-items-dialogue"}>
                  {reviewListHeader && <h3>{reviewListHeader}</h3>}
                  <ul className="receipt-review-checkoff">
                    {instructions.map((instruction, index) => {
                      return (
                        <li key={`form-checkoff-item-${index}`}>
                         {/*} <Check />*/}
                          <div className="receipt-review-checkoff-inside">
                            <span dangerouslySetInnerHTML={{ __html: instruction.desc }}></span>
                          </div>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </li>

              <li className="form__element checkbox-row" key={`formik-field-eighteenOrOver`}>
                <div className="input-row">
                  <Field
                    type="checkbox"
                    value={values.eighteenOrOver}
                    component={Checkbox}
                    name="eighteenOrOver"
                    touched={touched.eighteenOrOver && true ? "true" : ""}
                    onChange={e => {
                      setFieldValue("eighteenOrOver", e.target.checked)
                    }}
                  />

                  <label htmlFor="eighteenOrOver">*I am 18 years of age or older.</label>
                </div>

                <div className="input-row">{errors.eighteenOrOver && <p className="error">{errors.eighteenOrOver}</p>}</div>
              </li>

              {state.customConfirmation && (
                <li className="form__element checkbox-row" key={`formik-field-customConfirmation`}>
                  <div className="input-row">
                    <Field
                      type="checkbox"
                      value={values.customConfirmation}
                      component={Checkbox}
                      name="customConfirmation"
                      touched={touched.customConfirmation && true ? "true" : ""}
                      onChange={e => {
                        setFieldValue(`customConfirmation`, e.target.checked)
                      }}
                    />

                    <label htmlFor={`customConfirmation`} dangerouslySetInnerHTML={{ __html: "*" + state.customConfirmation }}></label>
                  </div>

                  <div className="input-row">{errors.customConfirmation && <p className="error">{errors.customConfirmation}</p>}</div>
                </li>
              )}

              <li className="form__element checkbox-row" key={`formik-field-termsAccepted`}>
                <div className="input-row">
                  <Field
                    type="checkbox"
                    value={values.termsAccepted}
                    component={Checkbox}
                    name="termsAccepted"
                    touched={touched.termsAccepted && true ? "true" : ""}
                    onChange={e => {
                      setFieldValue("termsAccepted", e.target.checked)
                    }}
                  />

                  <label htmlFor="termsAccepted">
                    *By clicking Submit, I acknowledge that I have read and agree to be bound by the Breaktime Media MWH, LLC{" "}
                    <a href="https://www.dailybreak.com/terms" target="_blank">
                      Terms &amp; Conditions
                    </a>{" "}
                    and{" "}
                    <a href="https://www.dailybreak.com/privacy" target="_blank">
                      Privacy Policy
                    </a>
                    .
                  </label>
                </div>
                <div className="input-row">{errors.termsAccepted && <p className="error">{errors.termsAccepted}</p>}</div>
              </li>
                { (nonFieldErrors.length > 0) && 
                    <li className="form__submit_errors" key={`formik-submit-errors`}>
                        { nonFieldErrors.map((error) => {
                            return (
                                <p className="error">{error}</p>
                            )
                        })}
                    </li>
                }
                {(addressValid === false) && 
                <li className="form__usps_errors" key={`formik-usps-errors`}>
                    <p className="error">Please enter a valid mailing address.</p>  
                </li>
                }
              <li className="form__submit-wrapper" key={`formik-field-cta`}>
                <div className={`receipt-button-container`}>
                  <input disabled={uploadSuccessful===false} className="btn themed-button" type="submit" value="Submit" />
                </div>
              </li>
            </ul>
          </form>
        )
      }}
    </Formik>
  )
}


const ReviewView = props => {
  const children = props.children
  let headline = props.headerTitle
  let introCopy = props.headerSubtitle
  let files = props.files
  let onUploadSuccessful = props.onUploadSuccessful
  let onRemove = props.onRemove
  let onUploadError = props.onUploadError
  let uploadSuccessful = props.uploadSuccessful
  let handleFileSelection = props.handleFileSelection
  let uploadID = props.uploadID
  return (
    <div className="receipt-view review-view">
      
      <div className={`receipt-view-header`}>
        {headline && <h2 className="receipt-header-headline" dangerouslySetInnerHTML={{ __html: headline }} />}
        {introCopy && <p className="receipt-header-desc" dangerouslySetInnerHTML={{ __html: introCopy }} />}
      </div>
      <Uploads handleFileSelection={handleFileSelection} onError={onUploadError} onSuccess={onUploadSuccessful} files={files} onRemove={onRemove} />
    
      <div className={`receipt-view-content`}>
        {children}
        <SubmissionForm {...props} uploadSuccessful={uploadSuccessful} editMySubmission={props.editMySubmission} uploadID={uploadID} />
      </div>
    </div>
  )
}
export { ReviewView, SubmissionForm }
